import { render, staticRenderFns } from "./GroupTypeForm.vue?vue&type=template&id=0856294d"
import script from "./GroupTypeForm.vue?vue&type=script&lang=js"
export * from "./GroupTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports